import { databases } from "@/lib/appwrite";
import { calculateLeaveDuration } from "@/requests/leaves/lib/calculateLeaveDuration";
import { getUserWithProfile } from "../../workerProfile-Users/getUserWithProfile";
import { ID } from "appwrite";
import { sendLeaveRequestToN8n } from "@/requests/leaves/webhook/sendRequestLeaveToN8n";
import { type BaseLeaveRequest } from "@/lib/collections/requestsLeave/types";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const LEAVES_COLLECTION_ID = import.meta.env.VITE_LEAVES_REQUESTS_COLLECTION_ID;

export interface CreateLeaveRequestParams {
    userId: string;
    startDate: Date;
    endDate: Date;
    allDay: boolean;
    comment?: string;
    title: string;
}

export type LeaveRequest = BaseLeaveRequest;

export async function createLeaveRequest(
    params: CreateLeaveRequestParams
): Promise<LeaveRequest> {
    try {
        const { userId, startDate, endDate, allDay, comment = "", title } = params;

        // Calcular la duración total en segundos
        const totalDurationInSeconds = calculateLeaveDuration(startDate, endDate, allDay);

        if (totalDurationInSeconds <= 0) {
            throw new Error(
                "Las horas deben estar dentro del horario laboral (8:00 AM - 5:00 PM)."
            );
        }

        // 1. Crear el registro de permiso
        const leaveRequest = await databases.createDocument(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            ID.unique(),
            {
                userId,
                status: "pending",
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                approvedById: null,
                comment,
                allDay,
                totalDuration: totalDurationInSeconds,
                title,
                statusByRrhh: "pending"
            }
        );

        // 2. Enviar webhook a n8n (mismo patrón que travel)
        try {
            const userProfile = await getUserWithProfile(userId);
            const supervisorId = userProfile?.profile?.idSupervisor;
            const supervisorProfile = supervisorId
                ? await getUserWithProfile(supervisorId)
                : null;
            const supervisorEmail = supervisorProfile?.email ?? "";

            await sendLeaveRequestToN8n(
                leaveRequest.$id,
                title,
                userProfile?.name ?? "",
                userProfile?.email ?? "",
                supervisorEmail,
                startDate,
                endDate,
                allDay,
                comment
            );
        } catch (webhookError) {
            console.warn("Error enviando webhook (registro guardado):", webhookError);
        }

        return leaveRequest as unknown as LeaveRequest;

    } catch (error) {
        console.error("Error creating leave request:", error);
        throw error;
    }
}

export async function getUserLeaveRequests(
    _userId: string
): Promise<LeaveRequest[]> {
    try {
        const response = await databases.listDocuments(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            []
        );

        return response.documents as unknown as LeaveRequest[];
    } catch (error) {
        console.error("Error fetching leave requests:", error);
        throw error;
    }
}

export function secondsToHours(seconds: number): number {
    return seconds / 3600;
}

export function hoursToSeconds(hours: number): number {
    return hours * 3600;
}